<template>
  <div class="candidate-auth">
    <div class="header">
      <img src="@/assets/images/talentPlaza/logo-bg.png" class="logo-bg" />
      <img src="@/assets/images/talentPlaza/logo.png" class="logo" />
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "candidateAuthIndex",
};
</script>

<style lang="scss" scoped>
.header {
  height: 85px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .logo-bg {
    width: 100%;
    height: 245px;
    top: 0;
    left: 0;
  }
  .logo {
    width: 71px;
    height: 28px;
    top: 21px;
    left: 15px;
  }
}
</style>
